const DEFAULT_WEEKS_COUNT = 14;
const DAYS_IN_TWO_WEEKS = 14;
const QUICKSTOCK_LEADTIMES = [3, 7, 14];
const QUICKSTOCK_ESTIMATION_DAYS = 14;
export const DAYS_IN_WEEK = 7;

export function getEstimatedDeliveryDate(leadtime: number, hasQuickstockItem: boolean) {
    if (hasQuickstockItem && QUICKSTOCK_LEADTIMES.includes(leadtime)) {
        return `${QUICKSTOCK_ESTIMATION_DAYS} days`;
    }

    let weeks = 0;

    if (isNaN(leadtime)) {
        weeks = DEFAULT_WEEKS_COUNT;
    } else if (leadtime < DAYS_IN_TWO_WEEKS) {
        return `${DAYS_IN_TWO_WEEKS} days`;
    } else {
        weeks = Math.floor(leadtime / DAYS_IN_WEEK);
    }

    return `${weeks} weeks`;
}